export default __webpack_public_path__ + "static/media/tennisBanner.c4271f1e.webp";